<template>
  <div class="px-8">
    <v-card class="pb-3 mb-10 rounded-10 elevation-card mt-4">
      <v-card-title>
        <span
          class="font-weight-700 fs-20 lh-16 pl-1 bluedarken--text text-uppercase"
          style="align-self: center"
        >
          {{ tab === 'all' ? 'SN Indonesia' : tab }}
        </span>
        <v-spacer></v-spacer>
        <v-icon
          color="bluedarken"
          style="font-size: 22px !important"
          id="refreshBudget"
          @click="refresh"
        >
          refresh
        </v-icon>
      </v-card-title>
      <v-card-text class="px-3 py-2">
        <v-row xs12 class="px-2 pl-5">
          <v-spacer></v-spacer>
          <!-- <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="btn-column"
                class="primary--text pb-0 mr-3"
                depressed
                color="lightblue"
                v-bind="attrs"
                v-on="on"
              >
                Select Column
              </v-btn>
            </template>
            <v-list-item-group
              v-model="columnActive"
              multiple
              class="menuColumn"
            >
              <div
                class="px-4 py-2"
                @click="selectAllColumn()"
                style="cursor:pointer;"
              >
                <v-row>
                  <v-flex xs2 class="ml-4" style="max-width: 37px !important;">
                    <v-icon v-if="isSelectedAll" color="primary accent-4">
                      check_box
                    </v-icon>
                    <v-icon color="primary accent-4" v-else>
                      check_box_outline_blank
                    </v-icon>
                  </v-flex>
                  <v-flex xs8 class="pt-1">
                    <v-list-item-title class="text-left">
                      Select All
                    </v-list-item-title>
                  </v-flex>
                </v-row>
              </div>
              <template v-for="(item, i) in columnTable">
                <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>
                <v-list-item
                  v-else
                  :key="`item-${i}`"
                  :value="item"
                  class="text-left"
                  style="max-height: 48px !important;"
                  active-class="primary--text text--accent-4"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-content style="max-width: 20px !important;">
                    </v-list-item-content>

                    <v-list-item-action style="width: 100%">
                      <v-flex xs12>
                        <v-row>
                          <v-flex xs2>
                            <v-icon color="primary accent-4" v-if="active">
                              check_box
                            </v-icon>
                            <v-icon v-else color="primary accent-4">
                              check_box_outline_blank
                            </v-icon>
                          </v-flex>
                          <v-flex xs8 class="pt-1">
                            <v-list-item-title class="text-left" v-text="item">
                            </v-list-item-title>
                          </v-flex>
                        </v-row>
                      </v-flex>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-menu> -->
        </v-row>
        <v-col sm="12" class="px-2">
          <v-simple-table fixed-header class="spending-table nav-table mt-1">
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    colspan="1"
                    style="background: #fff !important; border-right: none !important"
                  ></th>
                  <!-- <th
                    colspan="4"
                    class="rounded-7 white--text"
                    style="border: 2px solid #fff !important;"
                  >
                    FY BUDGET USAGE
                  </th>
                  <th
                    colspan="7"
                    class="rounded-7 white--text"
                    style="border: 2px solid #fff !important;"
                  >
                    TOPLINE SPENDING
                  </th> -->
                  <th
                    colspan="3"
                    class="rounded-7 white--text text-center"
                    style="border: 2px solid #fff !important;"
                  >
                    AR1 ACTUAL LANDING
                  </th>
                  <!-- <th
                    colspan="3"
                    class="rounded-7 white--text"
                    style="border: 2px solid #fff !important; border-right: 0"
                  >
                    YTD LANDING
                  </th>
                  <th
                    rowspan="2"
                    class="white--text rounded-top-left-7 rounded-top-right-7"
                    style="border: 2px solid #fff !important; border-bottom: 0"
                  >
                    Control AR1
                  </th>
                  <th
                    colspan="7"
                    class="rounded-7 white--text"
                    style="border: 2px solid #fff !important; border-left: 0"
                  >
                    PO MONITORING FY
                  </th>
                  <th
                    colspan="8"
                    class="rounded-7 white--text"
                    style="border: 2px solid #fff !important; border-left: 0"
                  >
                    PO MONITORING YTD
                  </th> -->
                </tr>
                <tr class="primary ">
                  <th class="f-14 white--text font-weight-medium">
                    {{
                      tab === 'all'
                        ? 'Department - House / Brand'
                        : 'Department'
                    }}
                  </th>
                  <!-- <th class="f-14 white--text">
                    Sign Off 2020
                  </th>
                  <th class="f-14 white--text">
                    Transfer In
                  </th>
                  <th class="f-14 white--text">
                    Transfer Out
                  </th>
                  <th class="f-14 white--text">
                    Wishlist/Pull Forward
                  </th>
                  <th class="f-14 white--text">
                    Budget Cut
                  </th>
                  <th class="f-14 white--text">
                    Total Adjustment
                  </th>
                  <th class="f-14 white--text">
                    Landing Estimate (LE)
                  </th> -->
                  <!-- <th class="f-14 white--text">
                    IO Amount
                  </th>
                  <th class="f-14 white--text">
                    % LE
                  </th>
                  <th class="f-14 white--text">
                    Remaining Budget
                  </th>
                  <th class="f-14 white--text">
                    % LE
                  </th>
                  <th class="f-14 white--text">
                    IO YTD
                  </th>
                  <th class="f-14 white--text">
                    Actual
                  </th>
                  <th class="f-14 white--text">
                    Commitment
                  </th>
                  <th class="f-14 white--text">
                    Pulling Forward
                  </th>
                  <th class="f-14 white--text">
                    Spending
                  </th>
                  <th class="f-14 white--text">
                    Remaining IO
                  </th>
                  <th class="f-14 white--text">
                    % vs IO
                  </th> -->
                  <th class="f-14 white--text font-weight-medium">
                    Actual
                  </th>
                  <th class="f-14 white--text font-weight-medium">
                    Accrual
                  </th>
                  <!-- <th class="f-14 white--text">
                    GRIR
                  </th>
                  <th class="f-14 white--text">
                    Realization 2019
                  </th>
                  <th class="f-14 white--text">
                    Reverse 2019
                  </th> -->
                  <th class="f-14 white--text font-weight-medium">
                    YTD Landing
                  </th>
                  <!-- <th class="f-14 white--text">
                    Remaining IO
                  </th>
                  <th class="f-14 white--text">
                    % Spend vs IO
                  </th>
                  <th class="f-14 white--text">
                    Manual
                  </th>
                  <th class="f-14 white--text">
                    RF Landing
                  </th>
                  <th class="f-14 white--text">
                    AR1
                  </th>
                  <th class="f-14 white--text">
                    IO Amount
                  </th>
                  <th class="f-14 white--text">
                    PO Amount
                  </th>
                  <th class="f-14 white--text">
                    GR
                  </th>
                  <th class="f-14 white--text">
                    Outstanding IO
                  </th>
                  <th class="f-14 white--text">
                    % IO
                  </th>
                  <th class="f-14 white--text">
                    Outstanding PO
                  </th>
                  <th class="f-14 white--text">
                    % PO
                  </th>
                  <th class="f-14 white--text">
                    IO Amount
                  </th>
                  <th class="f-14 white--text">
                    PO Amount
                  </th>
                  <th class="f-14 white--text">
                    GR
                  </th>
                  <th class="f-14 white--text">
                    ACT Non PO
                  </th>
                  <th class="f-14 white--text">
                    Outstanding IO
                  </th>
                  <th class="f-14 white--text">
                    % IO
                  </th>
                  <th class="f-14 white--text">
                    Outstanding PO
                  </th>
                  <th class="f-14 white--text">
                    % PO
                  </th> -->
                </tr>
              </thead>
              <!-- </template>
            <template v-slot:body="{ items }"> -->
              <v-perfect-scroll
                class="drawer-menu--scroll-consolidatePO"
                :settings="scrollSettings"
              >
                <tbody v-if="itemsTamp.length > 0">
                  <template v-for="(val, index) in itemsTamp">
                    <tr
                      v-if="val.type !== 'total'"
                      :key="'data' + index"
                      :class="bgColor(val.type)"
                    >
                      <td>
                        {{
                          val.name.includes('-')
                            ? val.name.split('-')[1]
                            : val.name
                        }}
                      </td>
                      <td class="text-right">
                        {{ idr(val.actual) }}
                      </td>
                      <td class="text-right">
                        {{ idr(val.accrual) }}
                      </td>
                      <td class="text-right">
                        {{ idr(val.ytd_landing) }}
                      </td>
                    </tr>
                  </template>
                </tbody>

                <tbody v-else>
                  <tr>
                    <td colspan="48" class="text-center">
                      No data displayed
                    </td>
                  </tr>
                </tbody>
              </v-perfect-scroll>
              <tbody v-if="itemsTamp.length > 0">
                <template v-for="(val, index) in itemsTamp">
                  <tr
                    v-if="val.type === 'total'"
                    :key="'data' + index"
                    :class="bgColor(val.type)"
                  >
                    <td class="borderBlue">
                      {{ val.name }}
                    </td>
                    <td class="text-right borderBlue">
                      {{ idr(val.actual) }}
                    </td>
                    <td class="text-right borderBlue">
                      {{ idr(val.accrual) }}
                    </td>
                    <td class="text-right borderBlue">
                      {{ idr(val.ytd_landing) }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-card-text>
    </v-card>
    <progress-dialog
      :show="progressDialogLoading"
      text="Please wait"
    ></progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
// import filterColumn from '../filterColumn';
import ProgressDialog from '../progress_dialog';

export default {
  props: {
    itemsTable: {
      type: Array,
      required: true
    },
    tab: {
      type: String,
      required: true
    }
  },
  components: {
    // 'filter-column': filterColumn,
    'progress-dialog': ProgressDialog
  },
  data() {
    return {
      progressDialogLoading: false,
      scrollSettings: {
        maxScrollbarLength: 60
      },
      costElements: [],
      itemsTamp: [],
      columnTable: [
        'Department',
        'IO Description',
        'Entity',
        'Brand/Division',
        'GL Account',
        'GL Account Description',
        'Actual',
        'Accrual',
        'YTD Landing'
      ],
      columnActive: [],
      isSelectedAll: true,
      itemEdited: {
        dept: '',
        entity_name: '',
        brand_division: '',
        cost_element: null,
        ar1_commitment_po: null,
        ar1_total_spending: null,
        ar1_actual: null
      }
    };
  },
  computed: {
    itemFull() {
      return this.itemsTable;
    }
  },
  watch: {
    itemsTable(val) {
      this.itemsTamp = val;
    },
    columnActive(val) {
      localStorage.setItem('columnActiveConsolidateIO', val);
      if (val.length !== this.columnTable.length) {
        this.isSelectedAll = false;
      } else {
        this.isSelectedAll = true;
      }
    }
  },
  created() {
    window.addEventListener('beforeunload', this.handleRefresh);
  },
  mounted() {
    this.getCostElement();
    this.itemsTamp = this.itemsTable;
    // set active column
    let column = localStorage.getItem('columnActiveConsolidateIO');
    let arrColumn = null;
    if (column) {
      arrColumn = column.split(',');
    } else {
      arrColumn = this.columnTable;
    }
    if (this.columnTable !== arrColumn) {
      this.columnActive = arrColumn;
    } else {
      this.columnActive = this.columnTable;
    }
  },
  methods: {
    getCostElement() {
      this.$store
        .dispatch('costElement/getAll', {
          limit: 10000
        })
        .then(data => {
          if (data.code === 200) {
            this.costElements = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    savePO(val) {
      this.progressDialogLoading = true;
      let id = val.id;
      let body = {
        dept: this.itemEdited.dept || val.dept,
        entity_name: this.itemEdited.entity_name || val.entity_name,
        brand_division: this.itemEdited.brand_division || val.brand_division,
        cost_element: this.itemEdited.cost_element
          ? this.itemEdited.cost_element.code
          : val.cost_element.code,
        cost_element_name: this.itemEdited.cost_element
          ? this.itemEdited.cost_element.desc
          : val.cost_element.desc,
        ar1_commitment_po:
          this.itemEdited.ar1_commitment_po || val.ar1_commitment_po,
        ar1_total_spending:
          this.itemEdited.ar1_total_spending || val.ar1_total_spending,
        ar1_actual: this.itemEdited.ar1_actual || val.ar1_actual
      };
      this.$store
        .dispatch('monthlyReport/editIO', { id: id, params: body })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            Swal.fire({
              title: 'Success!',
              text: `${data.message.text_en}`,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.refresh();
                this.reset();
              }
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    cancelPO(val, column) {
      this.itemEdited[column] = val[column];
    },
    editItem(val, variable) {
      this.itemEdited[variable] = val;
    },
    selectAllColumn() {
      if (this.isSelectedAll) {
        this.isSelectedAll = false;
        this.columnActive = [];
      } else {
        this.isSelectedAll = true;
        this.columnActive = this.columnTable;
      }
    },
    checkColspan(val) {
      let promo = [
        'Department',
        'IO Description',
        'Entity',
        'Brand/Division',
        'GL Account',
        'GL Account Description'
      ];
      let ar1 = ['Actual', 'Accrual', 'YTD Landing'];
      let columnPromo = [];
      let columnAr1 = [];
      for (let i = 0; i < promo.length; i++) {
        if (this.columnActive.includes(promo[i])) {
          columnPromo.push(promo[i]);
        }
      }
      for (let j = 0; j < promo.length; j++) {
        if (this.columnActive.includes(ar1[j])) {
          columnAr1.push(ar1[j]);
        }
      }
      if (val === 'promo') {
        return columnPromo.length;
      } else {
        return columnAr1.length;
      }
    },
    checkColspanTotal() {
      let column = [
        'Department',
        'IO Description',
        'Entity',
        'Brand/Division',
        'GL Account',
        'GL Account Description'
      ];
      let columnActive = [];
      for (let i = 0; i < column.length; i++) {
        if (this.columnActive.includes(column[i])) {
          columnActive.push(column[i]);
        }
      }
      return columnActive.length;
    },
    handleRefresh() {
      localStorage.setItem('columnActiveConsolidateIO', this.columnTable);
    },
    refresh() {
      this.$emit('getData');
    },
    getAscSort(obj) {
      this.itemsTamp.sort(this.dynamicSort(obj.fieldName));
    },
    getNestedSort(obj) {
      this.nestedSort(obj.fieldName, this.itemsTamp);
    },
    searchCln(obj) {
      let nameField = obj.fieldName;
      let arr = this.itemFull;
      let valSearch = Array.isArray(obj.value)
        ? obj.value.join('|').toLowerCase()
        : obj.value.toLowerCase();
      if (!nameField.includes('.')) {
        /*search array of object*/
        if (nameField === 'start') {
          nameField = 'dateStart';
        } else if (nameField === 'end') {
          nameField = 'dateEnd';
        }
        this.itemsTamp = arr.filter(function(a) {
          if (a[nameField] !== null) {
            if (Array.isArray(obj.value)) {
              return obj.value.includes(a[nameField].toString());
            } else {
              return a[nameField]
                .toString()
                .toLowerCase()
                .match(valSearch);
            }
          }
        });
      } else {
        /*search array of nested object*/
        let arrObj = nameField.split('.');
        if (arrObj.length === 2) {
          this.itemsTamp = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(a[arrObj[0]][arrObj[1]].toString());
              } else {
                return a[arrObj[0]][arrObj[1]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        }
      }
    },
    getFiltered(name) {
      if (!name.includes('.')) {
        let dataFiltered = this.itemFull.reduce((result, arr) => {
          result[arr[name]] = [...(result[arr[name]] || []), arr];
          return result;
        }, {});
        return Object.keys(dataFiltered);
      } else {
        let nameField = name.split('.');
        let dataFiltered = [];
        if (nameField.length === 2) {
          dataFiltered = this.itemFull.reduce((result, arr) => {
            if (!arr[nameField[0]]) return;
            result[arr[nameField[0]][nameField[1]]] = [
              ...(result[arr[nameField[0]][nameField[1]]] || []),
              arr
            ];
            return result;
          }, {});
        }
        return Object.keys(dataFiltered);
      }
    },
    reset() {
      this.itemEdited = {
        dept: '',
        entity_name: '',
        brand_division: '',
        cost_element: null,
        ar1_commitment_po: 0,
        ar1_total_spending: 0,
        ar1_actual: 0
      };
    },
    bgColor(type) {
      let color = '';
      switch (type) {
        case 'bo':
          color = 'white';
          break;
        case 'division':
          color = 'bgTotalDark font-weight-bold';
          break;
        case 'department':
          color = 'bgTotal font-weight-bold';
          break;
        case 'total':
          color = 'primary white--text font-weight-bold';
          break;
      }
      return color;
    }
  }
};
</script>

<style scoped>
.spending-table tbody {
  display: block;
  max-height: none !important;
}
.drawer-menu--scroll-consolidatePO {
  max-height: 425px;
  overflow: auto;
}
.table-po table {
  display: block;
  border-radius: 5px;
}
.table-po table th,
.table-po table td {
  white-space: nowrap !important;
  height: 30px !important;
}

.table-po table th {
  text-align: center !important;
  font-weight: 500 !important;
  background: #28a0f6;
}
/* width */
.table-po ::-webkit-scrollbar {
  height: 8px;
}
/* Track */
.table-po ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.table-po ::-webkit-scrollbar-thumb {
  background: #d5d5d5;
  border-radius: 20px;
}

/* Handle on hover */
.table-po ::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
.table-po td {
  height: 30px !important;
  border-right: 0.1px solid rgba(0, 0, 0, 0.12);
  border-left: 0.1px solid rgba(0, 0, 0, 0.12);
}
tr:hover {
  background-color: #f5f5f5;
}
.menuColumn {
  max-height: 250px;
}
.v-menu__content {
  background: #fff !important;
}
</style>
